import { addMinutes, getHours, getMinutes, getSeconds, set } from "date-fns";

import ActivityStatus from "@mapmycustomers/shared/enum/activity/ActivityStatus";
import PostponedDateGetter from "@mapmycustomers/shared/types/entity/activities/PostponedDateGetter";
import Activity from "@mapmycustomers/shared/types/entity/Activity";

import { parseApiDate } from "../parsers";

import getActivityStatus from "./getActivityStatus";

const postponeActivity = (activity: Activity, postponedDateGetter: PostponedDateGetter) => {
  const currentStartAt = parseApiDate(activity.startAt ?? "");
  const updatedStartAt = postponedDateGetter(
    getActivityStatus(activity) === ActivityStatus.OVERDUE
      ? set(Date.now(), {
          hours: getHours(currentStartAt),
          minutes: getMinutes(currentStartAt),
          seconds: getSeconds(currentStartAt),
        })
      : currentStartAt
  );

  return {
    ...activity,
    endAt: activity.duration ? addMinutes(updatedStartAt, activity.duration).toISOString() : null,
    startAt: updatedStartAt.toISOString(),
  };
};

export default postponeActivity;
